/* eslint-disable camelcase */
import httpClient from 'utils/httpClient';
import { UseQueryOptions, useQuery } from 'react-query';
import { AxiosResponse, AxiosError } from 'axios';
import { STATUS_CODE } from 'constants/common';
import { useHistory } from 'react-router-dom';

export const RETRIEVE_CURRENT_USER = '/v2/users/personal';

export type role = {
  id: number;
  name: string;
};
export type SalaryRateType = {
  amountCurrency: string;
  changedAt: string;
  hourlyAmount: number;
  id: number;
  name: string;
  note: string;
  topicId: number;
};
export type RetrieveCurrentUserResponse = {
  id: number;
  displayName: string;
  firstName: string;
  avatar: string;
  roles: role[];
  permissions: string[];
  salaryRates: SalaryRateType[];
  hidePayment: number;
  timeZone: string;
};

export const retrieveCurrentUser = () =>
  httpClient.get<RetrieveCurrentUserResponse>(RETRIEVE_CURRENT_USER);

export const useRetrieveCurrentUser = (
  opts?: UseQueryOptions<
    AxiosResponse<RetrieveCurrentUserResponse>,
    AxiosError<any>
  >,
) => {
  const history = useHistory();
  return useQuery<AxiosResponse<RetrieveCurrentUserResponse>, AxiosError<any>>(
    [RETRIEVE_CURRENT_USER],
    () => retrieveCurrentUser(),
    {
      retry: false,
      retryOnMount: false,
      refetchOnWindowFocus: false,
      onError: errors => {
        if (errors?.response?.status === STATUS_CODE.UNAUTHORIZED) {
          localStorage.removeItem('token');
          history.push('/sign-in');
        }
      },
      ...opts,
    },
  );
};
